import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { ClientsDataServiceProvider } from '@services/client/clients.data.service';
import { MessageService } from '@services/helpers/message-service/message.service';
import { EmailServiceProvider } from '@services/email/email-service/email.service';
import { Subject } from 'rxjs/Subject';

@Component({
	selector: 'resubscribe-client-modal',
	template: ''
})
export class ResubscribeClientModalComponent implements OnInit {
	@Output() successResubscribeClient: EventEmitter<any> = new EventEmitter();
	@Output() cancelResubscribeClient: EventEmitter<any> = new EventEmitter();

	button_disable: boolean;
	client: any;
	unsubscribe: Subject<void> = new Subject();

	constructor(
		public clientsDataService: ClientsDataServiceProvider,
		public messageService: MessageService,
		public emailService: EmailServiceProvider
	) {}

	ngOnInit() {
		this.emailService.clientToCheckSubscription$
			.takeUntil(this.unsubscribe)
			.subscribe(client => {
				this.client = client;
			});
	}

	ngOnDestroy() {
		this.emailService.emitClientToCheckSubscription(null);
		this.unsubscribe.next();
		this.unsubscribe.complete();
	}

	resubscribeClient(): void {
		this.button_disable = true;
		this.clientsDataService
			.changeClientSubscription(this.client)
			.finally(() => (this.button_disable = false))
			.subscribe(
				() => this.successResubscribeClientCallback(),
				error => this.messageService.showDefaultErrorMessage(error)
			);
	}

	successResubscribeClientCallback(): void {
		this.messageService.showToaster('s_0', 'subscribed');
		this.switchModal(true);
	}

	switchModal(isSuccess) {}
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/string-replace-webpack-plugin/loader.js?id=oom9nsliule!./web/modern/components/client/modals/resubscribe-client-modal/resubscribe-client-modal/resubscribe-client-modal.ts